import React, { useEffect, useRef, useState } from 'react'

import {
    getProcessButtons, getDtRowIndexNew, getError, isUndNullNew, sendMessageCloseCurrentWindow, getLanguageObj, getResponse,
    settings, LoadingSection
} from '../../helpers/UtilsHelper';
import useAuth from '../../auth/useAuth';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { MlSiteService } from '../../services/mercadoLibre/MlSiteService';
import TableIndex from '../main/TableIndex';

const $ = window?.$;
const { app, firebase, icons, images, labels, } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, } = firebase?.firestore;
const { urls } = app?.backend;

const currentMethod = 'MlSites - function';

export default function MlSites({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const dtSitesId = 'dtSites';
    const [process, setProcess] = useState({ showLoading: false, sync: false });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods (site)
    const getSiteAddEditDelete = async ({
        e = null,
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'getSiteAddEditDelete';
        let response = getResponse({ type: 0 });
        try {
            if (e) e.preventDefault();
            setProcess(prev => ({ ...prev, showLoading: true }));

            console.log({ id, description, rowIndex, processType, subMethod });
            // Logic for different processTypes (Add/Edit/Delete/Sync) goes here
            // For now, mirroring existing functionality
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region dataTable / queryCode
            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion dataTable / queryCode

            //#region get data (sites)
            const token = auth?.account?.tokenVzLaML?.token;
            const ordersBy = [
                { field: dbFields?.name, value: dbOrdersBy?.asc, },
            ];

            response = await MlSiteService.getAll({ token, ordersBy, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning) return;

            const sitesLocal = response?.result || [];
            //#endregion get data (sites)

            //#region set dataTable
            let sitesDtLocal = [];
            if (sitesLocal?.length > 0) {
                sitesDtLocal = sitesLocal.map((detail) => {
                    return [
                        detail?.name,
                        detail?.siteId,
                        detail?.currencyId,
                        getProcessButtons({
                            id: detail?.id,
                            description: detail?.name,
                            detailsShow: false,
                            editShow: false,
                            deleteShow: true,
                            deleteLabel: labels?.delete?.[languageObj?.id],
                            deleteEnabled: true,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result
                    ];
                });
            }

            $(`#${dtSitesId}`).DataTable().clear().rows.add(sitesDtLocal).draw(true);
            //#endregion set dataTable
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtSitesId}`).DataTable({
                destroy: true,
                data: [],
                order: [[0, 'desc']],
                columns: [
                    { title: labels?.name?.[languageObj?.id], width: '75%', orderable: true, },
                    { title: labels?.code?.[languageObj?.id], width: '10%', orderable: true, },
                    { title: labels?.currency?.[languageObj?.id], width: '10%', orderable: true, },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, searchable: false },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtSitesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtSitesId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowIndexLocal = getDtRowIndexNew({ dtId: dtSitesId, this_: this, subMethod: currentMethod })?.result;
                if (!isUndNullNew({ data: rowIndexLocal, subMethod: currentMethod, })?.result) {
                    const methodValueLocal = e?.target?.attributes?.method?.value || '';
                    const idLocal = e?.target?.attributes?.id?.value || '';
                    const descriptionLocal = e?.target?.attributes?.description?.value || '';
                    switch (methodValueLocal) {
                        case 'edit':
                            getSiteAddEditDelete({
                                e: e,
                                id: idLocal,
                                description: descriptionLocal,
                                rowIndex: rowIndexLocal,
                                processType: 1,
                                subMethod: currentMethod
                            });
                            break;
                        case 'delete':
                            getSiteAddEditDelete({
                                e: e,
                                id: idLocal,
                                description: descriptionLocal,
                                rowIndex: rowIndexLocal,
                                processType: -1,
                                subMethod: currentMethod
                            });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='settings' process='metrics' processLevel1='sites' />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.sites?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.sites?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='card border-0 shadow-lg login-card' >
                            <LoadingSection alt='loadingSection'
                                className='overlay dark text-white'
                                height={20}
                                hidden={!process?.showLoading}
                                width={20}
                                languageId={languageObj?.id}
                                subMethod={currentMethod} />

                            <div className='card-header bg-white border-0 pt-4 px-4'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <img alt='imgSites'
                                                style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                src={images?.icons?.siteMap} />
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.sites?.[languageObj?.id]}</h5>
                                            <div className='mt-1'>
                                                <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                    <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <button className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                        disabled={process?.showLoading}
                                        onClick={(e) => getSiteAddEditDelete({ e: e, id: '', description: '', rowIndex: 0, processType: 3, subMethod: 'btnSync' })}
                                        title={labels?.sync?.[languageObj?.id]}>
                                        <i className={`${icons?.sync} mr-1`} /> {labels?.sync?.[languageObj?.id]}
                                    </button>
                                </div>
                            </div>

                            <div className='card-body px-4 pb-4'>
                                <TableIndex tableId={dtSitesId} languageObj={languageObj} />
                            </div>

                        </div>

                    </div>
                </section>

            </div>
        </div>
    )
}